import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "rosangela4030-lgpd-ok";

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="lgpd-cookie-notice"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          role="region"
          aria-label="Aviso de privacidade e cookies"
          className="fixed bottom-5 left-5 z-[60] max-w-sm rounded-3xl border border-slate-200 bg-white/95 p-6 shadow-2xl backdrop-blur-xl"
        >
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl bg-brand-royal/10 text-brand-royal">
              <Cookie className="h-5 w-5" />
            </span>
            <div>
              <p className="font-display text-sm font-bold text-slate-900">Privacidade em primeiro lugar</p>
              <p className="mt-1 text-xs leading-relaxed text-slate-500">
                Usamos apenas armazenamento local para lembrar sua preferência. Os dados do formulário de contato são
                tratados conforme a LGPD (Lei nº 13.709/2018).
              </p>
              <button
                type="button"
                data-testid="lgpd-accept-button"
                onClick={accept}
                className="mt-3 rounded-full bg-brand-dark px-5 py-2 text-xs font-bold text-white transition-transform hover:-translate-y-0.5"
              >
                Entendi e aceito
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
